import React from 'react';
import { authRoles } from 'app/auth';

export const FileManagerAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.user, 
	routes: [
		{
			path: '/files',
			component: React.lazy(() => import('./FileManagerApp'))
		}
	]
};
